import PropTypes from 'prop-types';
import { Box, CardContent, Stack, Typography } from '@mui/material';

const styles = {
  cardContent: {
    padding: 'unset !important',
  },
};

export const UserCardContent = ({ info }) => (
  <CardContent sx={styles.cardContent}>
    <Stack spacing={1}>
      {info.map(({ label, value }) => {
        const formattedLabel = label.toLowerCase();
        const isNameInfo = formattedLabel === 'name';
        const isEmailInfo = formattedLabel === 'email';

        return (
          <Box
            key={formattedLabel}
            display="grid"
            gridTemplateColumns={isNameInfo || isEmailInfo ? '1fr' : '3fr 2fr'}
            alignItems="center"
            gap={1}
          >
            <Typography variant="body2-bold">{label}:</Typography>

            <Typography variant={isNameInfo ? 'body2-bold' : 'body2'} noWrap={isNameInfo || isEmailInfo}>
              {value}
            </Typography>
          </Box>
        );
      })}
    </Stack>
  </CardContent>
);

UserCardContent.propTypes = {
  info: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.node,
    }),
  ).isRequired,
};
